import { render } from "./MarketingEventEditorCmp.vue?vue&type=template&id=2354d420"
import script from "./MarketingEventEditorCmp.vue?vue&type=script&lang=js"
export * from "./MarketingEventEditorCmp.vue?vue&type=script&lang=js"

import "./MarketingEventEditorCmp.vue?vue&type=style&index=0&id=2354d420&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__